<template>
  <div>
    <ContentHeader path-set-type="replace" :path-info="navPathInfo" :show-back="false" />
    <div class="content-container">
      <div class="order-eval-block">
        <div class="eval-header">
          <span>评 价</span>
          <span>
            共
            <i>{{orderItemQty}}</i>个物品待评价
          </span>
        </div>
        <div
          class="eval-content"
          v-for="(material,index) in evaluationInfo.purchaseOrderEvaluateList"
          :key="material.itemId"
          :class="{evalContentBorder:index + 1 !== orderInfo.detailList.length }"
        >
          <el-row>
            <el-col :span="3" :offset="1">
              <img class="material-img" :src="getImageUrl(orderInfo.detailList[index].pocmDTO)" alt />
              {{orderInfo.detailList[index].itemName}}
            </el-col>
            <el-col :span="6">
              <div class="rate-box">
                <i>*</i>物料质量 :
                <el-rate :colors="['#c8102d', '#c8102d', '#c8102d']" v-model="material.qualityScore"></el-rate>
              </div>
              <div class="rate-box">
                <i>*</i>物料美观 :
                <el-rate :colors="['#c8102d', '#c8102d', '#c8102d']" v-model="material.appearanceScore"></el-rate>
              </div>
              <div class="rate-box">
                <i>*</i>物流服务 :
                <el-rate :colors="['#c8102d', '#c8102d', '#c8102d']" v-model="material.serviceScore"></el-rate>
              </div>
            </el-col>
          </el-row>
          <div class="eval">
            <div class="eval-item">
              <div class="eval-name">评价:</div>
              <el-input class="eval-item-detail" type="textarea" v-model="material.scoreContent" show-word-limit maxlength="200"></el-input>
            </div>
            <div class="eval-item">
              <div class="eval-name">图片:</div>
              <div class="eval-item-detail">
                <el-upload
                  ref="upload"
                  :before-upload="checkBeforeUpload"
                  :on-success="(res,file)=>{handleImgSuccess(index,res,file)}"
                  :headers="uploadHeaders"
                  :accept="'image/*'"
                  class="avatar-uploader"
                  :action="fileUploadTarget"
                  list-type="picture-card"
                  multiple
                  :limit="limitCount"
                  :class="{hide:hideUpload}"
                  :on-change="handleImgChange"
                  :on-remove="handleImgRemove"
                >
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <template #file="{ file }">
                    <div>
                      <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                      <span class="el-upload-list__item-actions">
                        <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file,index)">
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                  </template>
                </el-upload>
              </div>
            </div>
          </div>
        </div>
        <div class="order-eval-block" style="text-align: center">
          <el-button class="btn-red" :loading="btnLoding" @click="submitEvaluation">提交评价</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import ContentHeader from '@/components/content-header'
import { tokenUtils } from '@/utils/auth'
import { mapState } from 'vuex'
import baseApi from '@/api/base'
export default {
  name: 'order-evaluation',
  components: {
    ContentHeader
  },
  data () {
    return {
      orderInfo: '',
      evaluationInfo: {
        orderId: 0,
        purchaseOrderEvaluateList: []
      },
      disabled: false,
      btnLoding: false,
      hideUpload: false,
      limitCount: 5
    }
  },
  computed: {
    ...mapState({
      fileUploadTarget: state => state.app.fileUploadTarget
    }),
    navPathInfo () {
      return [
        {
          path: '/order/list/pocm',
          name: '订单中心'
        }
      ]
    },
    orderItemQty () {
      return this.orderInfo.detailList.length
    },
    uploadHeaders () {
      return {
        Authorization: 'Bearer ' + tokenUtils.getToken(true),
        Accept: 'application/json'
      }
    }
  },
  created () {
    this.init()
  },
  beforeDestroy () {
    localStorage.removeItem('userInfo')
  },
  methods: {
    init () {
      this.orderInfo = JSON.parse(localStorage.getItem('orderInfo'))
      this.evaluationInfo.orderId = this.orderInfo.orderId
      this.setEvaluationInfo()
    },
    getImageUrl (item) {
      let imageUri = ''
      if (item.imageList && item.imageList.length > 0) {
        imageUri = item.imageList[0].imageFileUri
      }
      return commonUtils.getImageUrl(imageUri)
    },
    setEvaluationInfo () {
      for (let i = 0; i < this.orderItemQty; i++) {
        this.evaluationInfo.purchaseOrderEvaluateList.push({
          itemName: this.orderInfo.detailList[i].itemName,
          itemId: this.orderInfo.detailList[i].itemId,
          qualityScore: 0,
          appearanceScore: 0,
          serviceScore: 0,
          scoreContent: '',
          purchaseOrderEvaluateImageList: []
        })
      }
    },
    // 上传前检测
    checkBeforeUpload (file) {
      if (file.type.substr(0, 5) !== 'image') {
        this.$message.error('上传的文件不是图片文件，请重新上传')
        return false
      }
      let typeArr = ['jpg', 'jpeg', 'png', 'heic', 'heif']
      if (!typeArr.find(item => {
        return file.type.includes(item)
      })) {
        this.$message.error('图片格式不正确,仅支持jpg、jpeg 及 png,请重新上传')
        return false
      }
    },
    // 删除图片
    handleRemove (file, index) {
      if ((file?.response?.resultData?.fileDTO) || file.imageFileId) {
        const fileId = file.response
          ? file.response.resultData.fileDTO.fileId
          : file.imageFileId
        baseApi.deleteFile({ fileId: fileId }).then(res => {
          if (res.data.resultCode === '0') {
            this.$message.warning('删除图片成功')
          }
        })
      }
      this.$refs.upload[index].handleRemove(file)

      let imgIndex = this.evaluationInfo.purchaseOrderEvaluateList[index].purchaseOrderEvaluateImageList.findIndex(item => {
        return item.imageFileId === file.response.resultData.fileDTO.fileId
      })
      this.evaluationInfo.purchaseOrderEvaluateList[index].purchaseOrderEvaluateImageList.splice(imgIndex, 1)
    },
    // 上传成功 --
    handleImgSuccess (index, res, file) {
      if (res.resultCode === '0') {
        this.evaluationInfo.purchaseOrderEvaluateList[index].purchaseOrderEvaluateImageList.push({ imageFileId: res.resultData.fileDTO.fileId })
      }
    },
    // 提交评价
    submitEvaluation () {
      for (const i of this.evaluationInfo.purchaseOrderEvaluateList) {
        if (!i.qualityScore || !i.appearanceScore || !i.serviceScore) {
          this.$message.error(`请选择 ${i.itemName} 评分`)
          return
        }
      }
      this.btnLoding = true
      this.$store.dispatch('submitEvaluation', this.evaluationInfo).then(res => {
        this.btnLoding = false
        if (res.data.resultCode === '0') {
          this.$message.success('评价提交成功')
          this.$router.replace({
            path: '/order/list/pocm'
          })
        }
      }).catch(() => {
        this.btnLoding = false
      })
    },
    handleImgChange (file, fileList) {
      this.hideUpload = fileList.length >= this.limitCount
    },
    handleImgRemove (file, fileList) {
      this.hideUpload = fileList.length >= this.limitCount
    }
  }
}
</script>

<style lang="scss" scoped>
.order-eval-block {
  background-color: $base-white;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 10px;
}
.eval-header {
  padding: 0 60px;
  span {
    &:first-child {
      font-size: 28px;
      margin-right: 10px;
    }
    i {
      color: #c8102d;
    }
  }
}
.evalContentBorder {
  border-bottom: 1px dashed #a7a7a7;
}
.eval-content {
  padding: 35px 20px;
  text-align: center;
  .material-img {
    max-width: 100px;
    max-height: 100px;
    display: block;
    margin: 0 auto;
    padding-bottom: 10px;
  }
  .rate-box {
    height: 25px;
    line-height: 25px;
    margin-bottom: 15px;
    font-size: 16px;
    padding-left: 25px;
    i {
      color: #c8102d;
      margin-right: 5px;
    }
    .el-rate {
      height: 25px;
      line-height: 35px;
      float: right;
    }
  }
  .eval {
    margin-top: 40px;
    padding: 0 40px;
    .eval-item {
      display: flex;
      margin-bottom: 20px;
      .eval-name {
        width: 15%;
        font-size: 16px;
        font-weight: 700;
      }
      .eval-item-detail {
        width: 85%;
        &::v-deep textarea.el-textarea__inner {
          height: 70px;
          outline: none;
          // border: none;
        }
        &::v-deep .el-textarea__inner:focus {
          border-color: #dcdfe6;
        }
      }
    }
  }
}
.btn {
  width: 180px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 22px;
  color: $base-white;
  border-radius: 10px;
  background-color: #c8102d;
  margin: 0 auto;
  cursor: pointer;
}
.avatar-uploader {
  text-align: left;
}
.avatar-uploader ::v-deep .el-upload {
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader ::v-deep .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 110px;
  height: 110px;
  line-height: 110px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
::v-deep .el-upload--picture-card,
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 125px;
  height: 125px;
  line-height: 125px;
}
</style>
<style lang="scss">
.hide .el-upload--picture-card {
  display: none;
}
</style>
